import React, { useRef } from 'react';
import './LogoTooltip.scss';
import { createPopper } from '@popperjs/core';
import logo from '../assets/logo.svg';

function LogoTooltip({ logoTooltipContents }) {
  const tooltipRef = useRef();
  const handleMouseEnterLogo = (e) => {
    const content = tooltipRef.current;
    createPopper(e.target, content, {
      placement: 'bottom',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 5]
          }
        }
      ]
    });
    content.style.visibility = 'visible';
  };

  const handleMouseLeaveLogo = () => {
    const content = tooltipRef.current;
    content.style.visibility = 'hidden';
  };

  return (
    <>
      <a
        href={logoTooltipContents.href}
        target="_blank"
        rel="noreferrer"
        aria-label="Visit Destination Canada Homepage"
      >
        <img
          className="logo"
          src={logo}
          alt=""
          onMouseEnter={(e) => {
            handleMouseEnterLogo(e);
          }}
          onMouseLeave={handleMouseLeaveLogo}
        />
      </a>
      <div className="tooltip" ref={tooltipRef}>
        <p className="tooltip__text">Visit {logoTooltipContents.copy}</p>
      </div>
    </>
  );
}

export default LogoTooltip;
